import { render, staticRenderFns } from "./MessageNotification.vue?vue&type=template&id=c2834f62&scoped=true&"
import script from "./MessageNotification.vue?vue&type=script&lang=js&"
export * from "./MessageNotification.vue?vue&type=script&lang=js&"
import style0 from "./MessageNotification.vue?vue&type=style&index=0&id=c2834f62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2834f62",
  null
  
)

export default component.exports